import { defineStore } from 'pinia'
import type { appUserInfo } from '../services/loginApi'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    userInfo: null as appUserInfo | null,
  }),

  actions: {
    setUserInfo(userInfo: appUserInfo) {
      this.userInfo = userInfo
    },
    clearUserInfo() {
      this.userInfo = null
    },
    getUserInfo() {
      return this.userInfo
    }
  },

  getters: {
    isAuthenticated: (state) => state.userInfo !== null
  }
})
